// extracted by mini-css-extract-plugin
export default {"option":"add-aws-credentials_option__SS8Nv","formSection":"add-aws-credentials_formSection__AIfwm"};